// extracted by mini-css-extract-plugin
module.exports = {"container":"Responses_container__1_Smu","info":"Responses_info__107D0"};